module.exports = __webpack_public_path__ + "img/iconfont.2794b1ca.svg";